import { render, staticRenderFns } from "./Convenios-otros.vue?vue&type=template&id=19dc0d30&scoped=true"
import script from "./Convenios-otros.vue?vue&type=script&lang=js"
export * from "./Convenios-otros.vue?vue&type=script&lang=js"
import style0 from "./Convenios-otros.vue?vue&type=style&index=0&id=19dc0d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc0d30",
  null
  
)

export default component.exports